<div class="page">
  <div class="header">
    <div class="header-text">
      <h1><strong>{{ empresa?.nomeRazao || 'Empresa' }}</strong></h1>
    </div>
  </div>

  <div class="box" *ngIf="empresa">
    <div class="box-header">
      <div class="box-col">
        <strong>CNPJ OU CPF</strong><br />
        {{ empresa.cpfCnpj }}<br />
      </div>

      <div class="box-col">
        <strong>RG / INSCRIÇÃO ESTADUAL</strong><br />
        <div class="value">{{ empresa.rgIE || '-' }}</div>
      </div>

      <div class="box-col">
        <strong>NOME EMPRESARIAL</strong><br />
        {{ empresa.nomeRazao }}<br />
      </div>

      <div class="box-col box-col--small">
        <div class="company-type">
          <div class="label">TIPO PESSOA</div>
          <div class="value">{{ empresa.tipoPessoa}}</div>
        </div>
      </div>

    </div>
  </div>


  <div class="section" *ngIf="empresa">
    <div class="row grid-4">
      <div>
        <div class="label">LOGRADOURO (RUA)</div>
        <div class="value">{{ empresa.endereco }}</div>
      </div>
      <div>
        <div class="label">NÚMERO</div>
        <div class="value">{{ empresa.numero }}</div>
      </div>
      <div>
        <div class="label">COMPLEMENTO</div>
        <div class="value multiline">{{ empresa.complemento || '' }}</div>
      </div>
      <div>
        <div class="label">CEP</div>
        <div class="value">{{ empresa.cep }}</div>
      </div>
    </div>

    <div class="row grid-4">
      <div>
        <div class="label">BAIRRO</div>
        <div class="value">{{ empresa.bairro }}</div>
      </div>
      <div>
        <div class="label">MUNICÍPIO/UF</div>
        <div class="value">{{ empresa.cidade }} / {{ empresa.estado }}</div>
      </div>
      <div>
        <div class="label">E-MAIL</div>
        <div class="value">{{ empresa.email }}</div>
      </div>
      <div>
        <div class="label">DATA CADASTRO</div>
        <div class="value">{{ empresa.dataCadastro ? (empresa.dataCadastro | date:'dd/MM/yyyy') : '-' }}</div>
      </div>
    </div>

    <div class="row grid-5">
      <div>
        <div class="label">CONTATO</div>
        <div class="value">{{ empresa.contato }}</div>
      </div>
      <div>
        <div class="label">TELEFONE</div>
        <div class="value">{{ empresa.telefone }} </div>
      </div>
      <div>
        <div class="label">CELULAR</div>
        <div class="value">{{ empresa.celular }}</div>
      </div>
      <div>
        <div class="label">facebook</div>
        <div class="value">{{ empresa.facebook }}</div>
      </div>
      <div>
        <div class="label">instagram</div>
        <div class="value">{{ empresa.instagram }}</div>
      </div>        
    </div>

    <div class="row grid-4">
      <div>
        <div class="label">Data de Aquisição</div>
          <div class="value">
            {{ empresa.dataAquisicao ? (empresa.dataAquisicao | date:'dd/MM/yyyy') : '-' }}
          </div>
      </div>
      <div>
        <div class="label">Vencimento</div>
          <div class="value">
            {{ empresa.dataVencimento ? (empresa.dataVencimento | date:'dd/MM/yyyy') : '-' }}
          </div>
      </div>
      <div>
        <div class="label">Plano assinatura</div>
        <div class="value">{{ empresa.planoAssinatura }}</div>
      </div>
      <div>
        <div class="label">Periodo restante </div>
        <div class="value">{{ formatarMesesEDias(empresa) }}</div>
      </div>    
    </div>
  </div>

  <div *ngIf="!empresa && !loading && !errorMessage">Nenhuma empresa encontrada para o tenant atual.</div>
  <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
  <div *ngIf="loading">Carregando dados da empresa...</div>
</div>

<router-outlet></router-outlet>
